export const CanvasFactory = Symbol.for("CanvasFactory");

export const Context2dFactory = Symbol.for("Context2dFactory");